module.exports = "/_next/static/images/PersonalizationStrategies-c67695dc3592078e6b61385981e827c2.webp";